<template>
  <div :class="{'modal':true, 'is-active':show}">

    <div class="modal-background" @click="$emit('close-modal')"></div>
    <div class="modal-card">
        <div class="box has-text-centered">
            <h3 class="title is-3 has-text-grey-dark">¡Vota por MUCRISIS!</h3>
            <div class="columns is-vcentered is-centered">
                <div class="column has-text-centered">
                    <a href="https://topg.org/es/mu-private-servers/in-605568" target="_blank" rel="nofollow">
                        <img :src="vote.topg" 
                            width="88" height="53" 
                            alt="Mu Online Private Servers" 
                            class="border-logo">
                    </a>
                </div>
                <div class="column has-text-centered">
                    <a href="http://top.tuservermu.com.ve/vote/449" target="_blank" rel="nofollow">
                        <img :src="vote.tuservermu" 
                        alt="TOP TUServerMU - MuOnline Private Servers List Ranking" 
                        class="border-logo">
                    </a>
                </div>
                <div class="column has-text-centered">
                    <a href="https://www.arena-top100.com/index.php?a=in&u=crisis" target="_blank" rel="nofollow">
                        <img :src="vote.arena" 
                        alt="MU Online Private Servers" 
                        width="88" height="53"
                        class="border-logo" />
                    </a>
                </div>
            </div>
        <article class="notification is-info is-light">
            <div class="notification-body">
                <b>Información:</b> <br>Puedes votar por nuestro servidor cada 12 horas. <br> ¡No dudes en volver a Votar!
            </div>
        </article>
        </div>

    </div>

  </div>
</template>

<script>
export default {
    name:'VoteModal',
    props: {
        show: {
            default:false,
            type:Boolean
        }
    },
    computed: {
        vote() {
            return this.$store.state.vote
        }
    }
}
</script>

<style scoped>
    .border-logo {
        border-radius: 8px;
    }
</style>